import { render, staticRenderFns } from "./popup-sk.vue?vue&type=template&id=3baa9244&scoped=true"
import script from "./popup-sk.vue?vue&type=script&lang=js"
export * from "./popup-sk.vue?vue&type=script&lang=js"
import style0 from "./popup-sk.vue?vue&type=style&index=0&id=3baa9244&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa9244",
  null
  
)

export default component.exports